export enum ButtonType {
  Cancel,
  OpenAction,
  OpenTab
}
